export function RecoveryResult({ data, beat }) {
  const result = data.microtracerBeats[`beat${beat}`]?.recoveryResult;
  return <>{result}</>;
}
